import {
	getAiAgentRepository,
	getDashboardRepository,
	getHubRepository,
	getInvestmentRepository,
	getInvestorRepository,
	getOrganizationRepository,
	getOrgInvitationRepository,
	getProjectRepository,
	getBeneficiaryRepository,
	getTemplateRepository,
	getUserProfileRepository,
} from "@/infrastructure/di";

import {
	getOrgStorageService,
	getAiAgentSessionService,
	getFileDownloadService,
} from "@/infrastructure/di/services";

export function useDashboardRepository() {
	return getDashboardRepository();
}

export function useUserProfileRepository() {
	return getUserProfileRepository();
}

export function useTemplateRepository() {
	return getTemplateRepository();
}

export function useInvestorRepository() {
	return getInvestorRepository();
}

export function useInvestmentRepository() {
	return getInvestmentRepository();
}

export function useBeneficiaryRepository() {
	return getBeneficiaryRepository();
}

export function useProjectRepository() {
	return getProjectRepository();
}

export function useOrganizationRepository() {
	return getOrganizationRepository();
}

export function useHubRepository() {
	return getHubRepository();
}

export function useOrgInvitationRepository() {
	return getOrgInvitationRepository();
}

export function useAiAgentRepository() {
	return getAiAgentRepository();
}

export function useOrgStorageService() {
	return getOrgStorageService();
}

export function useAiAgentSessionService() {
	return getAiAgentSessionService();
}

export function useFileDownloadService() {
	return getFileDownloadService();
}
